import {Breadcrumb, Col, Layout, Menu, Row, Typography} from "antd";
import './styles/patient-layout.css'
import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";
import PatientDropdown from "./PatientDropdown";
import TicariConsentModal from "./TicariConsentModal";
import {LocalStorageService} from "../core/service/LocalStorageService";
import {t} from "i18next";
import { Branding } from "../core/service/BrandingService";

const { Header, Content, Footer } = Layout;
export default function PatientLayout({children}) {
    const history = useHistory();
    const [config, setConfig] = useState({});

    const init = async () => {
        const config = window.AppSettings;
        setConfig(config);
    }

    useEffect(() => {
        init()
    }, []);

    return (
        <Layout className="layout" style={{minHeight: '100vh'}}>
            <TicariConsentModal />
            <Header>
                <div
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    }}
                >
                    <img className="logo" src={Branding.asset('loginLogo')} alt={Branding.displayName() || 'Logo'} height={48}/>
                    <div style={{color: 'white'}}>
                        <PatientDropdown />
                    </div>
                </div>
            </Header>
            <Content
                style={{
                }}
            >
                <div className="site-layout-content" style={{marginTop: 32}}>
                    {children}
                </div>
            </Content>
            <Footer style={{textAlign: 'start', backgroundColor: '#212529', color: 'white', marginTop: 32}}>
                <div style={{display: 'flex', alignItems: 'start', gap: 12, justifyContent: 'center', flexWrap: 'wrap'}}>
                    <div style={{
                        flex: 1,
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        <div style={{width: 300, fontSize: '11pt'}}>
                            <img className="logo" src={Branding.asset('loginLogo')} alt={Branding.displayName() || 'Logo'} height={48}/>
                            <br/><br/>
                            {Branding.description('online', LocalStorageService.getLanguage('tr'))}
                        </div>
                    </div>
                    <div style={{
                        flex: 1,
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column', alignItems: 'center'}}>
                        <div style={{fontSize: '11pt'}}>
                            <Typography.Title level={3} style={{color: 'white'}}>
                                {t('Working Hours')}
                            </Typography.Title>
                            {
                                Branding.onlineHours(LocalStorageService.getLanguage('tr')).map(h => (
                                    <div><Typography.Text style={{color: 'white'}}>{h}</Typography.Text></div>
                                ))
                            }
                        </div>
                    </div>
                    <div style={{flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <div style={{fontSize: '11pt'}}>
                            <Typography.Title level={3} style={{color: 'white'}}>
                                {t('Contact')}
                            </Typography.Title>
                            {
                                Branding.onlineContact(LocalStorageService.getLanguage('tr')).map(h => {
                                    if(!h)
                                        return (<p></p>)

                                    return (
                                        <div>
                                            <Typography.Text
                                                style={{
                                                    color: 'white',
                                                    wordWrap: 'break-word'
                                                }}>{h}</Typography.Text>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </Footer>
        </Layout>
    )
}